module.exports = __webpack_public_path__ + "static/ss2.421ffb7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss2.png
// module id = 1197
// module chunks = 81679748166845